
export const bgAdmin = {
  styles: {
    global: (props) => ({
      body: {
        // bgImage: bgBody,
        bgSize: "cover",
        bgPosition: "center center",
      },
    }),
  },
};
